import { gsap } from "gsap";
import loadImages from './loadImages.js';
import * as THREE from 'three';
import GUI from 'lil-gui';
import VirtualScroll from 'virtual-scroll'

export default class PlainGallery {
    constructor() {
        this.controls = null;
        this.camera = null;
        this.scene = null;
        this.renderer = null;
        this.raycaster = null;
        this.pointer = document.querySelector('.pointer-story');
        this.mouse = new THREE.Vector2();
        this.aspect = window.innerWidth / window.innerHeight < 1 ? 'portrait' : 'landscape';
        this.velocityFactor = { drag: {landscape: 0.015, portrait: 0.018}, scroll: {landscape: 0.001, portrait: 0.003} };
        this.cameraPos = { landscape: { z: 35 }, portrait: { z: 60 } };
        //this.cameraPos = { landscape: { z: 400 }, portrait: { z: 60 } };
        this.meshes = [];
        this.meshesText = [];
        this.scrollVelocity = 0;
        this.dragVelocityY = 0;
        this.dragVelocityX = 0;
        this.isScrolling = false;
        this.isDragging = false;
        this.previousMousePosition = { x: 0, y: 0 };
        this.previousTouchPosition = { x: 0, y: 0 };
        this.inertiaFactor = 0.95;
        //this.lines = 40;
        //this.lines = 1;
        //this.gui = new GUI();
        this.items = [];
        this.itemsDimensions = [14, 9];
        this.gridSpacingX = 10;
        this.gridSpacingY = 8;
        this.gridSizeX = 0;
        this.gridSizeY = 0;
        this.isTouchEnabled = 'ontouchstart' in window;

        this.scroller = new VirtualScroll();
        this.init();
    }

    init() {
        try {
            // this.setupGUI();
            this.setupCamera();
            this.setupScene();
            this.setupItems();
            this.loadMedia();
            this.setupRenderer();
            // this.setupControls();
            this.setupRaycaster();
            this.addEventListeners();
            this.animate();
        } catch (error) {
            console.error('Initialization failed:', error);
        }
    }

    setupItems() {

        if(three_items){
            this.items = three_items;
        }else{
            const domItems = document.querySelectorAll('[data-archive-item]');

            if(domItems.length > 0){

                domItems.forEach(item => {
                    
                    this.items.push({
                        img: item.querySelector('[data-archive-image]').src,
                        link: item.href,
                        title: item.querySelector('[data-archive-title]').innerHTML,
                        text: item.querySelector('[data-archive-subtitle]').innerHTML
                    });
                });
            }
        }
    }

    setupGUI() {
        const myObject = {
            myNumber: 1
        };
        this.gui.add(myObject, 'myNumber', 0, 100);
    }

    setupCameraZoom() {
        this.camera.position.z = this.cameraPos[this.aspect].z;
    }

    setupCamera() {
        this.camera = new THREE.PerspectiveCamera(20, window.innerWidth / window.innerHeight, 0.1, 1000);
        this.setupCameraZoom();
    }

    setupScene() {
        this.scene = new THREE.Scene();
    }

    async loadMedia() {
        const loaded = await loadImages(this.items, this.itemsDimensions);
        if (!loaded || !loaded.images) throw new Error('Failed to load images');
        this.createImageMeshes(loaded.images, loaded.count);
    }

    randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    createImageMeshes(images) {
        this.gridSizeX = Math.ceil(this.items.length / 3) * 10; // Number of images in a row, rounded up
        this.gridSizeY = Math.ceil(this.items.length * 4); // Number of rows, rounded up

        this.boundaryX = this.gridSpacingX * this.items.length;
        this.boundaryY = this.gridSizeY;

        for (let y = 0; y < this.gridSizeY; y++) {
            const offsetX = (y % 2 === 0) ? 0 : this.gridSpacingX / 2; // Offset for even/odd rows to create staggered effect

            for (let x = 0; x < this.gridSizeX; x++) {
                // Calculate image index and ensure it cycles through available images
                const imageIndex = (y * this.gridSizeX + x) % this.items.length;

                // Calculate positions with spacing and offset
                const imageX = (x - this.gridSizeX / 2) * this.gridSpacingX + offsetX;
                const imageY = (y - this.gridSizeY / 2) * this.gridSpacingY;
                const imageZ = 0;

                // Create image mesh
                const imageMesh = new THREE.Mesh(images[imageIndex].geometry, images[imageIndex].material);
                imageMesh.position.set(imageX, imageY, imageZ);
                imageMesh.userData.link = images[imageIndex].link;
                this.scene.add(imageMesh);

                const textX = imageX - this.itemsDimensions[0] / 4;
                const textY = imageY - this.itemsDimensions[1] / 4;

                // Create text mesh

                let titleGeometry = images[imageIndex].titleGeometry;
                let titleMaterial = images[imageIndex].titleMaterial;
                const titleMesh = new THREE.Mesh(titleGeometry, titleMaterial);
                titleGeometry.computeBoundingBox();
                titleMesh.position.set(textX, textY - 0.5, imageZ);
                this.scene.add(titleMesh);

                let textGeometry = images[imageIndex].textGeometry;
                let textMaterial = images[imageIndex].textMaterial;
                const textMesh = new THREE.Mesh(textGeometry, textMaterial);
                textGeometry.computeBoundingBox();
                textMesh.position.set(textX, textY - 0.8, imageZ);
                this.scene.add(textMesh);

                // Store meshes for interaction
                this.meshes.push(imageMesh);
                this.meshesText.push(textMesh);
            }
        }
    }


    setupRenderer() {
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.setAnimationLoop(this.animate.bind(this));
        document.body.appendChild(this.renderer.domElement);
    }

    setupRaycaster() {
        this.raycaster = new THREE.Raycaster();
    }

    addEventListeners() {
        window.addEventListener('resize', this.onWindowResize.bind(this));
        //window.addEventListener('wheel', this.onWheel.bind(this));

        if(this.isTouchEnabled === false){
            window.addEventListener('mousedown', this.onPointerDown.bind(this));
            window.addEventListener('mousemove', this.onPointerMove.bind(this));
            window.addEventListener('mouseup', this.onPointerUp.bind(this));
        }else{
            window.addEventListener('touchstart', this.onPointerDown.bind(this));
            window.addEventListener('touchmove', this.onPointerMove.bind(this));
            window.addEventListener('touchend', this.onPointerUp.bind(this));
        }

        this.renderer.domElement.addEventListener('click', this.onClick.bind(this));
        this.scroller.on(this.onWheel.bind(this));
    }

    onWindowResize() {
        this.aspect = (window.innerWidth / window.innerHeight) < 1 ? 'portrait' : 'landscape';
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.setupCameraZoom();
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }

    // onWheelOld(event) {
    //     this.scrollVelocity += event.deltaY * 0.001;
    //     this.isScrolling = true;
    // }

    onWheel(event) {

        //let deltaX = event.deltaX === 0 ? event.deltaY / 4 : event.deltaX;
        this.scrollVelocity -= event.deltaY * this.velocityFactor.scroll[this.aspect];
        this.dragVelocityX += event.deltaX * this.velocityFactor.scroll[this.aspect];
        this.isScrolling = true;
    }   

    onPointerDown(event) {
        
        if(this.isTouchEnabled === false){
            event.preventDefault();
        }

        if(event.which === 3) {
            this.onPointerUp();
            return;
        }

        this.isDragging = true;
        this.previousMousePosition.y = event.clientY || event.touches[0].clientY;
        this.previousMousePosition.x = event.clientX || event.touches[0].clientX;

        this.camera.position.x -= this.dragVelocityX;

        // console.log('down');
        gsap.to(this.camera.position, { z: this.cameraPos[this.aspect].z + 2, duration: 0.4, ease: 'power2.out' });
    }

    onPointerMove(event) {
        if(this.isTouchEnabled === false){
            event.preventDefault();
        }
        
        this.mouse.x = ((event.clientX || event.touches[0].clientX) / window.innerWidth) * 2 - 1;
        this.mouse.y = -((event.clientY || event.touches[0].clientY) / window.innerHeight) * 2 + 1;

        this.raycaster.setFromCamera(this.mouse, this.camera);
        const intersects = this.raycaster.intersectObjects(this.meshes);

        if (intersects.length > 0) {
            const intersectedMesh = intersects[0].object;
            if (!intersectedMesh.userData.hovered) {
                intersectedMesh.userData.hovered = true;
                gsap.to(intersectedMesh.scale, { x: 1.1, y: 1.1, z: 1.2, duration: 0.8, ease: 'power2' });
            }
        } else {
            document.body.style.cursor = this.isDragging ? 'grabbing' : 'auto';
            this.meshes.forEach(mesh => {
                if (mesh.userData.hovered) {
                    mesh.userData.hovered = false;

                    gsap.to(mesh.scale, { x: 1, y: 1, z: 1, duration: 0.8, ease: 'power2.out' });
                }
            });
        }

        if (this.isDragging) {
            const deltaY = (event.clientY || event.touches[0].clientY) - this.previousMousePosition.y;
            const deltaX = (event.clientX || event.touches[0].clientX) - this.previousMousePosition.x;
            this.previousMousePosition.y = event.clientY || event.touches[0].clientY;
            this.previousMousePosition.x = event.clientX || event.touches[0].clientX;
            this.dragVelocityY = deltaY * this.velocityFactor.drag[this.aspect];
            this.dragVelocityX = deltaX * this.velocityFactor.drag[this.aspect];

            this.camera.position.y += this.dragVelocityY;
            this.camera.position.x -= this.dragVelocityX;
        }

        if (this.dragVelocityY === 0 && this.dragVelocityX === 0 && this.scrollVelocity === 0) {
            this.raycaster.setFromCamera(this.mouse, this.camera);
            const intersects = this.raycaster.intersectObjects(this.meshes);

            intersects.length > 0 ? this.pointer.classList.add('visible') : this.pointer.classList.remove('visible');
        }
    }

    onPointerUp(event) {
        if(this.isTouchEnabled === false){
            event.preventDefault();
        }
        document.body.style.cursor = 'pointer';
        this.isDragging = false;

        // console.log('up');

        gsap.to(this.camera.position, { z: this.cameraPos[this.aspect].z, duration: 0.4, ease: 'power2.out' });
    }

    onClick(event) {
        if (this.dragVelocityY === 0 && this.dragVelocityX === 0 && this.scrollVelocity === 0) {
            
            this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
            
            this.raycaster.setFromCamera(this.mouse, this.camera);
            const intersects = this.raycaster.intersectObjects(this.meshes);
            
            if (intersects.length > 0) {
                const intersectedMesh = intersects[0].object;
                window.open(intersectedMesh.userData.link, '_self');
            }
        }
    }

    applyInertia() {

        if (this.isScrolling) {
            this.scrollVelocity *= this.inertiaFactor;
            if (Math.abs(this.scrollVelocity) < 0.01) {
                this.scrollVelocity = 0;
                this.isScrolling = false;
            }
            this.camera.position.y -= this.scrollVelocity;
        }

        if ((!this.isDragging && this.dragVelocityY !== 0) || (!this.isDragging && this.dragVelocityX !== 0)) {
            this.dragVelocityY *= this.inertiaFactor;
            this.dragVelocityX *= this.inertiaFactor;

            if (Math.abs(this.dragVelocityX) < 0.01) {
                this.dragVelocityX = 0;
            }
            if (Math.abs(this.dragVelocityY) < 0.01) {
                this.dragVelocityY = 0;
            }

            this.camera.position.y += this.dragVelocityY;
            this.camera.position.x -= this.dragVelocityX;
        }
        
        
        // Riposiziona la telecamera se oltrepassa i limiti
        if (this.camera.position.x > this.boundaryX) {
            this.camera.position.x -= 2 * this.boundaryX;
        } else if (this.camera.position.x < -this.boundaryX) {
            this.camera.position.x += 2 * this.boundaryX;
        }

        if (this.camera.position.y > this.boundaryY) {
            this.camera.position.y -= 2 * this.boundaryY;
        } else if (this.camera.position.y < -this.boundaryY) {
            this.camera.position.y += 2 * this.boundaryY;
        }
            
    }


    animate() {
        this.applyInertia();
        this.renderer.render(this.scene, this.camera);
    }
}
